import { SepiaEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const Sepia = wrapEffect(SepiaEffect)
